// extracted by css-extract-rspack-plugin
export default {"yearLevel":"mUaZx","monthsList":"hau5a"};